// src/layouts/StudentLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import StudentSidebar from '../components/StudentSidebar';
import Footer from '../components/Footer';
import './CommonLayout.css';

export default function StudentLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="common-layout">
      <StudentSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <div className={`common-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="common-content">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}